import { managedFarmPageInfo } from '../../constants/pageInfo/pageInfo.constant';

interface IOpenSimpleSmsToFieldOwner {
  fieldOwnerPhoneNumber: string;
  message: string;
}

const makeSmsBody = (message: string): string => {
  const serviceUrl = process.env.REACT_APP_CLIENT_URL;

  const body = `${message}
 
[플루바 마켓 - 대행반장]
${serviceUrl}${managedFarmPageInfo.entryPage.path}`;

  return body;
};

export const openSimpleSmsToFieldOwner = ({ fieldOwnerPhoneNumber, message }: IOpenSimpleSmsToFieldOwner) => {
  const smsBody = makeSmsBody(message);
  const smsLink = `sms:${fieldOwnerPhoneNumber}?&body=${encodeURIComponent(smsBody)}`;
  window.location.href = smsLink;
};
